import { Box } from '@material-ui/core';

import { AutoCartSummary } from '@/components/modules/_shared/CartSummary/AutoCartSummary';
import { useCheckoutSessionAutoCart } from '@/components/modules/CheckoutSession/Detail/CheckoutSessionDetail/Summary/Cart/Auto/hooks/useCheckoutSessionAutoCart';
import { CustomAlert } from '@/components/shared/components/CustomAlert';
import { CustomPaper } from '@/components/shared/components/CustomPaper';
import { Text } from '@/components/shared/components/Text';

export const CheckoutSessionAutoCart = () => {
  const {
    checkoutSessionEntity,
    checkoutSession,
    cartSummaryData,
    downPayment,
    discount,
    isUserAllowedToEditVehicleData,
    shouldShowEditVehicleDataLenderMessage,
    selectedLender,
  } = useCheckoutSessionAutoCart();

  if (!checkoutSessionEntity || !checkoutSession || !cartSummaryData || !downPayment || !checkoutSessionEntity.hasCart()) {
    return null;
  }

  return (
    <CustomPaper fill="paper">
      <AutoCartSummary
        cartSummaryData={cartSummaryData}
        downPayment={downPayment}
        discount={discount}
        checkoutSessionStatus={checkoutSession.status}
      />
      {isUserAllowedToEditVehicleData && shouldShowEditVehicleDataLenderMessage && (
        <Box mt={3}>
          <CustomAlert
            title={<Text tId={'EDIT_VEHICLE_DATA_IN_LENDER_PLATFORM'} dynamicDataTexts={[selectedLender]} />}
            severity="info"
          />
        </Box>
      )}
    </CustomPaper>
  );
};
